<script setup lang="ts">
import { Popover } from 'primevue'
import { ref } from 'vue'

defineProps<{
  info?: string | null
}>()

const infoPopover = ref<InstanceType<typeof Popover> | null>(null)

const showInfo = (event: Event) => {
  infoPopover.value?.show(event)
}

const hideInfo = () => {
  infoPopover.value?.hide()
}
</script>

<template>
  <div v-if="info" class="inline-block">
    <button
      type="button"
      class="group cursor-help p-0 text-gray-500 hover:text-gray-700 focus:outline-none"
      @click="showInfo"
      @mouseenter="showInfo"
      @mouseleave="hideInfo">
      <i class="pi pi-info-circle text-surface-500 group-focus:text-surface-900 size-4" />
    </button>
    <Popover ref="infoPopover">
      <div class="relative max-w-[40ch] p-1 pr-8 text-sm text-gray-600">
        <p>
          {{ info }}
        </p>
        <button class="absolute top-0 right-0 cursor-help p-1" @click="infoPopover?.hide()">
          <i class="pi pi-times text-surface-400 hover:text-surface-900 size-4 transition" />
        </button>
      </div>
    </Popover>
  </div>
</template>
